import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { BookService } from '../../services/book.service';
import { ReadingGroupMemberListDialogComponent } from '../../dialogs/reading-group-member-list-dialog/reading-group-members-dialog.component';
import { DialogService } from 'shared/ui';

@Component({
  selector: 'viewer-reading-group-records',
  templateUrl: './reading-group-records.component.html',
  styleUrl: './reading-group-records.component.scss',
})
export class ReadingGroupRecordsComponent implements OnInit, OnDestroy {
  @Input() isMine = true;
  @Input() memberId?: string;
  @Input() memberName?: string;

  public _activeTab: 'comment' | 'underline' = 'comment';
  public _bid?: string;
  public _isOwnedByUser = false;

  private _unsubscriber = new Subject<void>();

  constructor(
    private _bookService: BookService,
    private _dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this._bookService.book$
      .pipe(takeUntil(this._unsubscriber))
      .subscribe((book) => {
        this._bid = book?.meta?.bid;
        this._isOwnedByUser = book?.isOwnedByUser ?? false;
      });
  }

  ngOnDestroy(): void {
    this._unsubscriber.next();
    this._unsubscriber.complete();
  }

  public _onTabClick(tab: 'underline' | 'comment'): void {
    this._activeTab = tab;
  }

  public _onGroupSelectClick(): void {
    const dialogRef = this._dialogService.open(
      ReadingGroupMemberListDialogComponent,
      {
        data: {
          bid: this._bid!,
        },
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }

      this.memberId = result.memberId;
      this.memberName = result.memberName;
    });
  }
}
